import React from "react";
import styled from "styled-components";

import DynamicImage from "shared/General/components/DynamicImage/DynamicImage";
import {BLOG_POST_DETAILS_WIDTH, CONTENT_CARD_IMAGE_HEIGHT} from "../../constants";

const Image = styled(DynamicImage)`
    max-width: 100%;
    object-fit: cover;
    height: ${CONTENT_CARD_IMAGE_HEIGHT}px;
    width: 100%;
    display: inline-block;
`;

type BlogPostDetailImageMediaProps = {
    image: string;
} & React.ImgHTMLAttributes<HTMLImageElement>;

export const BlogPostDetailImageMedia = ({
    image,
    width,
    height,
    ...props
}: BlogPostDetailImageMediaProps) => {
    if (!width) {
        width = BLOG_POST_DETAILS_WIDTH;
    }
    return (
        <div
            style={{
                minHeight: `${CONTENT_CARD_IMAGE_HEIGHT}px`,
                height: `${CONTENT_CARD_IMAGE_HEIGHT}px`,
                width: "100%",
            }}
        >
            <Image
                {...props}
                options={{
                    width,
                    height,
                    smart: true,
                }}
                alt={""}
                src={image}
            />
        </div>
    );
};
